import { render } from "./AppError.vue?vue&type=template&id=fba5d246&scoped=true"
import script from "./AppError.vue?vue&type=script&lang=js"
export * from "./AppError.vue?vue&type=script&lang=js"

import "./AppError.vue?vue&type=style&index=0&id=fba5d246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba5d246"]])

export default __exports__